import { useNavigate } from "react-router-dom";
import Routes from "./helpers/Routes";

//#region Navegar ClientAssistancesHistoryDashboard
export const useNavigateToClientAssistancesHistoryDashboard = () => {
    const navigate = useNavigate();

    return (clientErpId: string | null | undefined, clientName: string | null | undefined) => {
        navigate(Routes.kpis.list7 ?? 'Rota Undefined', { state: { clientErpId, clientName } }); // state tem de ser usado, pq é uma prop da interface NavigateOptions
    };
};

